import React, { Component } from "react";
import { createPortal } from "react-dom";

export default class Portfolio extends Component {
	constructor() {
      super();
			this.state={
        selectedImage: null,
        isModalOpen: false
      }
	}

	openModal = (image) => {
		this.setState({
			selectedImage: image,
			isModalOpen: true
		});
		// Prevent body scroll when modal is open
		document.body.style.overflow = 'hidden';
	}

	closeModal = () => {
		this.setState({
			selectedImage: null,
			isModalOpen: false
		});
		// Restore body scroll when modal is closed
		document.body.style.overflow = 'unset';
	}

	render() {
		const portfolioImages = [
			"/images/portfolio/garage-1.jpg",
			"/images/portfolio/garage-2.jpg",
			"/images/portfolio/garage-3.jpg",
			"/images/portfolio/garage-4.jpg",
			"/images/portfolio/garage-5.jpg",
			"/images/portfolio/garage-6.jpg",
			"/images/portfolio/garage-7.jpg",
			"/images/portfolio/garage-8.jpg",
			"/images/portfolio/garage-9.jpg",
			"/images/portfolio/garage-10.jpg",
			"/images/portfolio/garage-11.jpg",
			"/images/portfolio/garage-12.jpg",
			"/images/portfolio/garage-13.jpg",
			"/images/portfolio/garage-14.jpg",
			"/images/portfolio/garage-15.jpg",
			"/images/portfolio/garage-16.jpg",
			"/images/portfolio/garage-17.jpg",
			"/images/portfolio/garage-18.jpg",
			"/images/portfolio/garage-19.jpg",
			"/images/portfolio/garage-20.jpg",
			"/images/portfolio/garage-21.jpg",
			"/images/portfolio/garage-22.jpg",
			"/images/portfolio/garage-23.jpg",
			"/images/portfolio/garage-24.jpg",
			"/images/portfolio/garage-25.jpg",
			"/images/portfolio/garage-26.jpg",
			"/images/portfolio/garage-27.jpg",
			"/images/portfolio/garage-28.jpg",
			"/images/portfolio/garage-29.jpg",
			"/images/portfolio/garage-30.jpg",
			"/images/portfolio/garage-31.jpg",
			"/images/portfolio/garage-32.jpg",
			"/images/portfolio/garage-33.jpg",
			"/images/portfolio/garage-34.jpg",
			"/images/portfolio/garage-35.jpg",
			"/images/portfolio/garage-36.jpg"
		];

		return (
      <div>
        {/* Header */}
        <div className="primary-background large-padding centered-text">
          <h1 className="white">Our Portfolio</h1>
          <p className="white subheading">View our recent garage door installations and projects</p>
        </div>

        {/* Portfolio Grid */}
        <div className="white-background small-padding">
          {Array.from({ length: 7 }, (_, rowIndex) => {
            const startIndex = rowIndex * 5;
            const isEvenRow = rowIndex % 2 === 0;
            
            return (
              <div key={rowIndex} className="row" style={{marginTop: rowIndex > 0 ? "0px" : "-80px", flexDirection: isEvenRow ? "row-reverse" : "row"}}>
                {/* Large Image */}
                <div className="small-12 medium-6" style={{padding: "5px"}}>
                  <div 
                    className="background-image-fill hover-grow" 
                    style={{
                      backgroundImage: `url('/images/portfolio/garage-${startIndex + 1}.jpg')`,
                      height: "600px",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onClick={() => this.openModal(`/images/portfolio/garage-${startIndex + 1}.jpg`)}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.02)";
                      e.target.style.boxShadow = "0 8px 30px rgba(0,0,0,0.25)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.boxShadow = "0 4px 20px rgba(0,0,0,0.15)";
                    }}
                  ></div>
                </div>

                {/* Small Images Grid */}
                <div className="small-12 medium-6">
                  <div className="row">
                    {[2, 3, 4, 5].map((offset, gridIndex) => (
                      <div key={gridIndex} className="small-6" style={{padding: "5px"}}>
                        <div 
                          className="background-image-fill hover-grow" 
                          style={{
                            backgroundImage: `url('/images/portfolio/garage-${startIndex + offset}.jpg')`,
                            height: "295px",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: "4px",
                            cursor: "pointer",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                          }}
                          onClick={() => this.openModal(`/images/portfolio/garage-${startIndex + offset}.jpg`)}
                          onMouseEnter={(e) => {
                            e.target.style.transform = "scale(1.02)";
                            e.target.style.boxShadow = "0 8px 30px rgba(0,0,0,0.25)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "scale(1)";
                            e.target.style.boxShadow = "0 4px 20px rgba(0,0,0,0.15)";
                          }}
                        ></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}

          {/* Final Image */}
          <div className="row" style={{marginTop: "20px"}}>
            <div className="small-12 medium-6" style={{padding: "5px"}}>
              <div 
                className="background-image-fill hover-grow" 
                style={{
                  backgroundImage: "url('/images/portfolio/garage-36.jpg')",
                  height: "500px",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  border: "1px solid rgba(0,0,0,0.1)"
                }}
                onClick={() => this.openModal("/images/portfolio/garage-36.jpg")}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.02)";
                  e.target.style.boxShadow = "0 8px 30px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 4px 20px rgba(0,0,0,0.15)";
                }}
              ></div>
            </div>
          </div>
        </div>

        {/* Lightbox Modal */}
        {this.state.isModalOpen && createPortal(
          <div 
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.9)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "fadeIn 0.3s ease"
            }}
            onClick={this.closeModal}
          >
            <div 
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                position: "relative"
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={this.state.selectedImage} 
                alt="Portfolio" 
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "90vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                  animation: "zoomIn 0.3s ease"
                }}
              />
            
            </div>
          </div>,
          document.body
        )}

        {/* Call to Action */}
        <div className="primary-background large-padding centered-text">
          <h3 className="white">Ready to Get Started?</h3>
          <p className="white subheading">Contact us for a free estimate on your garage door project</p>
          <a href="tel:(650) 255-4768" className="button accent-background white large-margin-top">
            Call (650) 255-4768
          </a>
        </div>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes zoomIn {
            from { transform: scale(0.8); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
        `}</style>
      </div>
		)
	}
} 


// WEBPACK FOOTER //
// ./src/pages/portfolio/index.js